var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-header panel-header-sm"})
}
var staticRenderFns = []

export { render, staticRenderFns }